<template>
    <VeeForm :validation-schema="regValidationSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div" class="col-12">
        <form class="reg-form" @submit="handleSubmit($event, onRegSubmit)" method="post" :action="this.baseUrl + '/enter-reg-submit'" ref="regForm">
            <div class="row gx-3 gy-2 w-100">
                <div class="col-12 col-sm-4 pt-2 reg-wrapper">
                    <Popper :content="errors.reg_plate" arrow placement="top" class="w-100 m-0 border-0" :show="errors.reg_plate ? true : false">
                        <Field id="reg_plate" name="reg_plate" type="text" class="reg-input fw-bold" placeholder="Enter Reg" autocomplete="off"/>
                    </Popper>
                </div>
                <div class="col-6 col-sm-4 pt-2">
                    <Popper :content="errors.reg_postcode" arrow placement="top" class="w-100 m-0 border-0" :show="errors.reg_postcode ? true : false">
                        <Field id="reg_postcode" name="reg_postcode" type="text" class="form-control reg-postcode text-navy" :value="postcode" placeholder="Postcode"/>
                    </Popper>
                </div>
                <div class="col-6 col-sm-4 pt-2">
                    <button type="submit" class="btn btn-primary">
                        <span class="m-0">Search By Reg</span>
                    </button>
                </div>
            </div>
        </form>
		<teleport to="body">
            <buy-again-modal :ba-modal-open="baModalOpen" :order="foundOrder" :image-base-path="imageBasePath"></buy-again-modal>
        </teleport>
    </VeeForm>
</template>

<script>
    import { Form as VeeForm, Field } from 'vee-validate';
    import * as yup from 'yup';

    export default {
        props: ['postcode', 'imageBasePath'],
        components: {
            VeeForm,
            Field
        },
        data() {
            const regValidationSchema = yup.object({
                'reg_plate': yup.string().required('registration is a required field'),
                'reg_postcode': yup.string().required('postcode is a required field').nullable()
            });

            return {
                regValidationSchema,
                baModalOpen: false,
                foundOrder: []
            }
        },
        mounted() {

        },
        methods: {
            async onRegSubmit(values, actions) {
                this.emitter.emit('isLoading', true);
                let vm = this;
                var registration = values.reg_plate;
                var postcode = values.reg_postcode;

                const response = await axios.post('/ajax/validate_reg/' + registration);

                if(response.data.car_exists == true)
                {
                    //If registration has at least 1 size option, check it has at least 1 option that is same front/rear
                    if(typeof response.data.car.options !== 'undefined' && response.data.car.options.length > 0)
                    {
                        var sizes = vm.sortSameSizeFrontAndRear(response.data.car.options);

                        //Find matching order from reg/sizes
                        var order = await vm.findOrderMatchingRegAndSize(registration, sizes, postcode);

                        //If a matching order has been found, launch buy again modal
                        if(order.data) {
                            this.emitter.emit('isLoading', false);
                            vm.baModalOpen = true;
                            vm.foundOrder = order.data;

                            //Track Buy Again Modal opening
                            if(typeof(this.$gtag) !== 'undefined') {
                                this.$gtag.event('BuyAgainModal', {
                                    'event_category' : 'BuyAgainModal',
                                    'event_label': '/seen-reg-' + registration
                                });
                            }
                            else {
                                console.log('gtag not loaded');
                            }
                        }
                        else {
                            vm.$refs.regForm.submit();
                        }
                    }
                    else {
                        this.emitter.emit('isLoading', false);
                        actions.setFieldError('reg_plate', 'No size options found for this registration');
                    }
                }
                else {
                    this.emitter.emit('isLoading', false);

                    //Custom validation, registration not found
                    actions.setFieldError('reg_plate', 'Registration not found.');
                }
            },
            // Following functions are for use with the Buy Again Modal
            sortSameSizeFrontAndRear: function(options) {
                var front_and_rear_same_sizes = [];

                //Loop through and check if any size options have the same front/rear sizes.
                _.forEach(options, function(value, index) {
                    if(value.back === '(Same as front tyre)') {
                        var size = value.front.split('/');
                        var formatted_size = size[0] + '/' + size[1] + 'R' + size[2].substr(0, 2);

                        front_and_rear_same_sizes.push(formatted_size);
                    }
                });

                return _uniq(front_and_rear_same_sizes);
            },
            async findOrderMatchingRegAndSize(registration, sizes, postcode) {
                var formData = new FormData();

                formData.append('registration', registration);
                _.forEach(sizes, function(value, index) {
                    formData.append('sizes[]', value);
                });
                formData.append('postcode', postcode);

                var response = await axios.post('/ajax/buy_again_modal', formData);

                return response;
            },
            onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                firstInvalidField[0].focus();
            },
        },
        computed: {

        }
    }
</script>
<style lang="scss" scoped>
    .error {
        color: red;
    }
    .reg-form {
        .reg-wrapper {
            .reg-input {
                width: 100%;
                border: 0;
                padding: 2.5px 5px;
                border-radius: 6px;
                background: #FDD52E !important;
                background-color: #FDD52E !important;
                border: 1px solid #CAAB25;
                text-align: center;
                color: #212121;
                font-size: 20px;
                text-transform: uppercase;
                &::placeholder {
                    color: #212121;
                    opacity: 1;
                }
            }
        }
        .btn {
            width: 100%;
        }
    }
    .reg-postcode {
        height: 35px;
        font-size: 1rem;
    }
</style>